export default selector => {
    document.querySelectorAll(selector).forEach(el => {
        if (el.clientWidth === el.scrollWidth) {
            return
        }

        el.classList.add('scrollable--active')

        let pos = { left: 0, x: 0 }

        const mouseMoveHandler = e => {
            el.scrollLeft = pos.left - (e.clientX - pos.x)
        }

        const mouseUpHandler = () => {
            el.style.removeProperty('user-select')

            el.removeEventListener('mouseup', mouseUpHandler)
            el.removeEventListener('mousemove', mouseMoveHandler)
        }

        const mouseDownHandler = e => {
            if (e.target.tagName === 'A') {
                return false;
            }

            el.style.cursor = 'grabbing'
            el.style.userSelect = 'none'

            pos = {
                x: e.clientX,
                left: el.scrollLeft
            }

            el.addEventListener('mouseleave', mouseUpHandler)
            el.addEventListener('mouseup', mouseUpHandler)
            el.addEventListener('mousemove', mouseMoveHandler)
        }

        el.addEventListener('mousedown', mouseDownHandler)
        el.addEventListener('scroll', () => {
            el.classList.toggle('scrollable--scrolled', el.offsetWidth + el.scrollLeft >= el.scrollWidth)
        })
    })
}